import React, {useState, useEffect} from "react"
import * as handlers from "../../../_redux/users/usersHandlers"
import UserFormWizard from "../../../user-form-wizard/UserFormWizard"
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import { useLocation } from "react-router-dom";

const CreateUser = ({history}) => {

    const [tab, setTab] = useState(1);
    const users = useSelector(({users}) => users, shallowEqual);
    const location = useLocation();
  
    // Redux dispatch
    const dispatch = useDispatch();

    /* Clear fields on success */
    useEffect(() => {
        if (users?.notification?.type === "success"){
            history.push("/users/create")
        }
    });

    /* Submit user Data */
    const submitData = data => {
        dispatch(handlers.addUser({...data.tab1, ...data?.tab2, ...data?.tab3}));
    }

    return <UserFormWizard 
                key={location.key}
                tab={users?.notification?.type === "success" ? 0 : tab} // Reset Tab on success
                setTab={setTab} 
                isLoading={users.isLoading} 
                submitData={submitData} 
            />
}


export default CreateUser;